import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import deLocale from "@fullcalendar/core/locales/de";
import { FaFilePdf } from "react-icons/fa";
import PageWrapper from "../components/PageWrapper";
import { FaRegCalendarPlus } from "react-icons/fa";

const events = [
  // === 2025 ===
  { title: "Vorstandssitzung & 1. Kassierung (18–19 Uhr)", start: "2025-01-09T18:00:00", end: "2025-01-09T19:00:00" },
  { title: "2. Kassierung (17–19 Uhr)", start: "2025-02-13T17:00:00", end: "2025-02-13T19:00:00" },
  { title: "Jahreshauptversammlung (19 Uhr)", start: "2025-02-13T19:00:00" },
  { title: "1. Arbeitseinsatz in Gosen (ab 9 Uhr)", start: "2025-04-05T09:00:00", end: "2025-04-06T00:00:00" },
  { title: "1. Angeltreff + Casting in Gosen + Vorstandsangeln (6–13 Uhr)", start: "2025-05-04T06:00:00", end: "2025-05-04T13:00:00" },
  { title: "Vorstandssitzung (ab 13:30 Uhr)", start: "2025-05-04T13:30:00" },
  { title: "2. Angeltreff in Gosen (15–21:30 Uhr)", start: "2025-07-05T15:00:00", end: "2025-07-05T21:30:00" },
  { title: "Sommerfest (ab 15 Uhr)", start: "2025-07-19T15:00:00" },
  { title: "Nachtangeln (inkl. Grillen und Lagerfeuer) (18–0 Uhr)", start: "2025-08-23T18:00:00", end: "2025-08-24T00:00:00" },
  { title: "3. Angeltreff + Casting in Gosen (6:30–13 Uhr)", start: "2025-09-14T06:30:00", end: "2025-09-14T13:00:00" },
  { title: "Vorstandssitzung (14–15 Uhr)", start: "2025-09-14T14:00:00", end: "2025-09-14T15:00:00" },
  { title: "4. Angeltreff (7–13 Uhr)", start: "2025-10-12T07:00:00", end: "2025-10-12T13:00:00" },
  { title: "2. Arbeitseinsatz in Gosen (ab 9 Uhr)", start: "2025-10-18T09:00:00", end: "2025-10-19T00:00:00" },
  { title: "Weihnachtsgrillen + Lagerfeuer in Gosen (ab 11 Uhr)", start: "2025-11-08T11:00:00" },

  // === 2026 ===
  { title: "Vorstandssitzung (18 Uhr)", start: "2026-01-22T18:00:00", end: "2026-01-22T19:00:00" },
  { title: "2. Kassierung (17–19 Uhr)", start: "2026-02-12T17:00:00", end: "2026-02-12T19:00:00" },
  { title: "Jahreshauptversammlung (19 Uhr)", start: "2026-02-12T19:00:00" },
  { title: "1. Arbeitseinsatz in Gosen (ab 9 Uhr)", start: "2026-04-18T09:00:00", end: "2026-04-18T23:59:00" },
  { title: "Vorstandssitzung (ab 13:30 Uhr)", start: "2026-05-01T13:30:00" },
  { title: "1. Angeltreff + Casting in Gosen + Vorstandsangeln (15–21 Uhr)", start: "2026-05-01T15:00:00", end: "2026-05-01T21:00:00" },
  { title: "2. Angeltreff in Gosen (6–13 Uhr)", start: "2026-06-07T06:00:00", end: "2026-06-07T13:00:00" },
  { title: "3. Angeltreff in Gosen (15–21:30 Uhr)", start: "2026-07-04T15:00:00", end: "2026-07-04T21:30:00" },
  { title: "Sommerfest (in Planung)", start: "2026-08-08T00:00:00" },
  { title: "Nachtangeln + Grillen (18–0 Uhr)", start: "2026-08-29T18:00:00", end: "2026-08-30T00:00:00" },
  { title: "4. Angeltreff + Casting in Gosen (6:45–13 Uhr)", start: "2026-09-27T06:45:00", end: "2026-09-27T13:00:00" },
  { title: "Vorstandssitzung (14–15 Uhr)", start: "2026-09-27T14:00:00", end: "2026-09-27T15:00:00" },
  { title: "2. Arbeitseinsatz in Gosen (ab 9 Uhr)", start: "2026-11-07T09:00:00", end: "2026-11-07T23:59:00" },
  { title: "Mitgliederversammlung (ab 11 Uhr)", start: "2026-11-28T11:00:00" },
  { title: "Weihnachtsgrillen + Lagerfeuer (ab 12 Uhr)", start: "2026-11-28T12:00:00" },

  // === 2027 ===
  { title: "Vorstandssitzung (ab 18 Uhr)", start: "2027-01-14T18:00:00" },
  { title: "1. Kassierung (17–19 Uhr)", start: "2027-02-11T17:00:00", end: "2027-02-11T19:00:00" },
  { title: "Jahreshauptversammlung (19 Uhr)", start: "2027-02-11T19:00:00" },
];

function toICSDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z"; // UTC format
}

function downloadICS(event) {
  const start = toICSDate(event.start);
  const end = event.end ? toICSDate(event.end) : start;

  const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Angelfreunde 1866//Kalender//DE
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${event.id || Date.now()}@angelfreunde1866.de
DTSTAMP:${toICSDate(new Date().toISOString())}
DTSTART:${start}
DTEND:${end}
SUMMARY:${event.title}
END:VEVENT
END:VCALENDAR`.trim();

  const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${event.title}.ics`;
  link.click();

  URL.revokeObjectURL(url);
}

const FullCalendarComponent = () => {
  return (
    <PageWrapper>
      <main>
        <section
          className="py-12 sm:py-16 min-h-screen"
          style={{
            backgroundImage: `url('/gradient_bg.svg')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          aria-labelledby="calendar-heading"
        >
          <div className="mx-auto max-w-6xl px-6 sm:px-6 lg:px-4 font-sans">
            <header className="mb-8">
              <h2 className="text-left text-base font-semibold text-sky-600 font-heading mb-2">
                Veranstaltungsplan
              </h2>
              <h1
                id="calendar-heading"
                className="text-left text-2xl font-bold tracking-tight text-gray-950 font-heading"
              >
                Unsere bevorstehenden Veranstaltungen
              </h1>
              <p className="mt-2 text-left text-base text-gray-700 font-body sm:text-lg">
                Hier findest du alle bevorstehenden Veranstaltungen unseres
                Angelvereins. Der Kalender wird regelmäßig aktualisiert, damit du stets informiert bleibst. Weitere Details findest du auch in der Veranstaltungsübersicht als PDF.
              </p>

              <div className="mt-4 flex flex-wrap gap-3">
                <a
                  href="/Veranstaltungsplan 2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-x-2 py-2 px-4 bg-sky-600 hover:bg-sky-700 text-white rounded-full text-sm transition group"
                >
                  <FaFilePdf className="group-hover:scale-110 group-hover:rotate-4 transition-transform" />
                  Veranstaltungsübersicht 2025 (PDF)
                </a>

                <a
                  href="/Veranstaltungsplan 2026.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-x-2 py-2 px-4 bg-sky-600 hover:bg-sky-700 text-white rounded-full text-sm transition group"
                >
                  <FaFilePdf className="group-hover:scale-110 group-hover:rotate-4 transition-transform" />
                  Veranstaltungsübersicht 2026 (PDF)
                </a>
              </div>
            </header>

            <section
              className="mt-8 bg-white p-4 rounded-2xl shadow-md"
              aria-label="Kalender mit Vereinsveranstaltungen"
            >
              <div className="text-xs sm:text-sm md:text-base">
                <FullCalendar
                  plugins={[dayGridPlugin]}
                  initialView="dayGridMonth"
                  locale={deLocale}
                  events={events}
                  height="auto"
                  headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "",
                  }}
                  fixedWeekCount={false}
                  displayEventTime={false}
                  eventDisplay="block"
                  eventColor="#0284c7"
                  dayMaxEventRows={true}

                  // ✅ Use JSX instead of HTML so Tailwind applies correctly
                  eventContent={(arg) => (
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-1 m-1">
                      <span className="whitespace-normal break-words leading-tight text-[9px] sm:text-[11px] lg:text-[11px] sm:w-[100%]  lg:w-[70%] sm:basis-[70%]">
                        {arg.event.title}
                      </span>

                      <button
                        className="m-1 sm:mt-0 flex-shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full bg-white text-sky-600 hover:bg-sky-100 ring-1 ring-sky-600 transition cursor-pointer self-start sm:self-auto"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          downloadICS(arg.event);
                        }}
                        aria-label="In Kalender speichern"
                        title="In Kalender speichern (.ics)"
                      >
                        <FaRegCalendarPlus className="w-3 h-3" />
                      </button>
                    </div>
                  )}

                />

              </div>
            </section>
          </div>
        </section>
      </main>
    </PageWrapper>
  );
};

export default FullCalendarComponent;
